import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { hideScrollbars, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingBlock: SpacingsValues.s56,
      marginBottom: 40,
      marginInline: 'auto',
      maxWidth: 'var(--max-width-02)',

      '& .brk': {
        display: 'block',
      },

      [mediaQuery(breakpoints.tablet)]: {
        paddingBlock: SpacingsValues.s40,
        marginBottom: 0,
      },
      [mediaQuery(breakpoints.mobile)]: {
        '& .brk': {
          display: 'inline',
        },
      },
    },
    title: {
      color: 'var(--x-black)',
      display: 'block',
      textAlign: 'center',
      marginBottom: 30,
      fontWeight: 500,
      paddingInline: SpacingsValues.s24,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        lineHeight: '36px',
        marginBottom: SpacingsValues.s24,
      },
    },
    subtitle: {
      textAlign: 'center',
      fontWeight: 500,
      color: '#5F5F5F',
      marginBottom: '32px',
    },
    tabs: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    tabButtons: {
      background: 'none',
      display: 'flex',
      flexWrap: 'wrap',
      gap: SpacingsValues.s16,
      maxWidth: '100%',
      marginBottom: 28,
      paddingBlock: 4,
      paddingInline: SpacingsValues.s24,
      overflowX: 'auto',
      whiteSpace: 'nowrap',

      ...hideScrollbars,

      [mediaQuery(breakpoints.tablet)]: {
        flexWrap: 'nowrap',
        marginBottom: SpacingsValues.s24,
        overflowX: 'auto',
      },
    },
    tabPanels: {
      width: '100%',
    },
    tabContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: SpacingsValues.s40,
      overflow: 'hidden',
      paddingInline: SpacingsValues.s24,

      '&>p.look-body': {
        fontSize: 16,
        lineHeight: '24px',
      },

      [mediaQuery(breakpoints.tablet)]: {
        gap: SpacingsValues.s32,
      },
    },
    description: {
      color: '#666',
      textAlign: 'center',
    },
    image: {
      width: '100%',
    },
    imgBackground: {
      alignItems: 'center',
      backgroundColor: '#f8f8f8',
      borderRadius: 56,
      display: 'flex',
      height: 470,
      justifyContent: 'center',
      width: 'min(100%, 900px)',

      [mediaQuery(breakpoints.tablet)]: {
        height: 'auto',
        padding: 8,
      },
    },
    imageWithBackground: {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  }),
  {
    name: 'TabSection',
  },
);

export default useStyles;
